import { Observable, map } from "rxjs";
import { WebServicesService } from "../webservices.service";
import { ApiService } from "./_api.service";
import { Doc, DocArticlesAvailability, DocArticleWarning } from "src/app/_models/doc";
import { Enums } from "src/app/_models/_enums";
import { DateContainer, GenericFile } from "src/app/_models/models";
import { environment } from 'src/environments/environment';

export class DocApiService {
    constructor(private _ws: WebServicesService) {}

    get(): Observable<Doc[]> {
        const url = `${environment.wsBaseUrl}/api/Doc/all`;
        return this._ws.getWithCache(url, ApiService.CACHEKEY_DOCS).pipe(
            map((docs: Array<any>) => {
                docs.map(doc => {
                    const state = Enums.DocState.find(x => x.id === doc.docState);
                    if (state) {
                        doc._docStateName = state.value;
                    }
                    doc.docDate = new Date(doc.docDate);
                    doc.startUsage = new Date(doc.startUsage);
                    doc.endUsage = new Date(doc.endUsage);
                    doc.startObligation = new Date(doc.startObligation);
                    doc.endObligation = new Date(doc.endObligation);
                    doc.createdDateTime = new Date(doc.createdDateTime);
                    doc.modifiedDateTime = new Date(doc.modifiedDateTime);
                    return doc;
                });
                return docs;
            }));
    }

    getList(ids: number[]): Observable<string> {
        const url = `${environment.wsBaseUrl}/api/Doc/list?${ids.map(id => `Id=${encodeURIComponent(id)}`).join('&')}`;
        return this._ws.getCsvContent(url);
    }

    getOne(id: number): Observable<Doc> {
        const url = `${environment.wsBaseUrl}/api/Doc/${encodeURIComponent(id)}`;
        return this._ws.getWithoutCache(url).pipe(
            map(doc => {
                const state = Enums.DocState.find(x => x.id === doc.docState);
                if (state) {
                    doc._docStateName = state.value;
                }
                doc.docDate = new Date(doc.docDate);
                doc.startUsage = new Date(doc.startUsage);
                doc.endUsage = new Date(doc.endUsage);
                doc.startObligation = new Date(doc.startObligation);
                doc.endObligation = new Date(doc.endObligation);
                doc.createdDateTime = new Date(doc.createdDateTime);
                doc.modifiedDateTime = new Date(doc.modifiedDateTime);
                return doc;
            }));
    }

    put(doc: Doc) {
        const url = `${environment.wsBaseUrl}/api/Doc/${encodeURIComponent(doc.id)}`;
        return this._ws.putJson(url, doc);
    }

    putConfirm(id: number) {
        const url = `${environment.wsBaseUrl}/api/Doc/confirm/${encodeURIComponent(id)}`;
        return this._ws.putJson(url, {});
    }

    post(doc: Doc): Observable<Doc> {
        const url = `${environment.wsBaseUrl}/api/Doc/`;
        return this._ws.postJson(url, doc);
    }

    delete(doc: Doc) {
        const url = `${environment.wsBaseUrl}/api/Doc/${encodeURIComponent(doc.id)}`;
        return this._ws.deleteHttp(url);
    }

    getStartObligation(startObligation: string): Observable<DateContainer> {
        const url = `${environment.wsBaseUrl}/api/Doc/startObligation/${encodeURIComponent(startObligation)}`;
        return this._ws.getWithoutCache(url);
    }

    getEndObligation(endObligation: string): Observable<DateContainer> {
        const url = `${environment.wsBaseUrl}/api/Doc/endObligation/${encodeURIComponent(endObligation)}`;
        return this._ws.getWithoutCache(url);
    }


    getArticleAvailability(id: number): Observable<DocArticleWarning[]> {
        const url = `${environment.wsBaseUrl}/api/Doc/CheckAvailability/${id}`;
        return this._ws.getWithoutCache(url);
    }
    
    putArticleAvailabilityNote(warnings: DocArticleWarning[]) {
        const url = `${environment.wsBaseUrl}/api/Doc/SaveAvailabilityNote`;
        return this._ws.putJson(url, warnings);
    }

    getArticlesAvailability(request: DocArticlesAvailability): Observable<DocArticleWarning[]> {
        const url = `${environment.wsBaseUrl}/api/Doc/CheckArticlesAvailability/`;
        return this._ws.postJson(url, request);
    }
}
